export default "__VITE_ASSET__3f8b788f__"